import { Chip, Stack } from '@mui/material';

import { CustomerIntakeResponseListItem } from '../../utils/customerIntakeApi';
import { useTranslation } from '../../i18n';

type CustomerIntakeConversionStatusProps = {
  status: CustomerIntakeResponseListItem['conversionStatus'];
};

const CustomerIntakeConversionStatus = ({
  status,
}: CustomerIntakeConversionStatusProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      spacing={0.5}
      useFlexGap
      flexWrap="wrap"
      aria-label={t('surveyResponses.conversionStatusAria')}
    >
      <Chip
        size="small"
        label={
          status.trialBooking
            ? t('surveyResponses.trialBookingDone')
            : t('surveyResponses.trialBookingPending')
        }
        color={status.trialBooking ? 'success' : 'default'}
        variant={status.trialBooking ? 'filled' : 'outlined'}
      />
      <Chip
        size="small"
        label={
          status.registration
            ? t('surveyResponses.registrationDone')
            : t('surveyResponses.registrationPending')
        }
        color={status.registration ? 'success' : 'default'}
        variant={status.registration ? 'filled' : 'outlined'}
      />
    </Stack>
  );
};

export default CustomerIntakeConversionStatus;
